<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'PicVerify',
})
</script>
<template>
  <div :class="bem({ icon: showIcon })">
    <Input v-model:value="value" ref="inputRef" size="large" :maxlength="4" placeholder="验证码" allow-clear>
      <template v-if="showIcon" #prefix>
        <BaseIcon type="icon-verifycode" />
      </template>
    </Input>
    <ImgCode ref="imgCodeRef" v-model:uuid="uuid" />
  </div>
</template>

<script lang="ts" setup name="PicVerify">
import { createNamespace } from '@bd/vue3-utils'
import { Input } from 'ant-design-vue'
import { ref } from 'vue'
import { BaseIcon } from '-/Base/BdIcon'
import ImgCode from './ImgCode.vue'

const [_, bem] = createNamespace('PicVerify')
defineProps<{
  showIcon?: boolean
}>()
const value = ref()
const uuid = ref()
const imgCodeRef = ref()
const inputRef = ref()
const refresh = () => {
  value.value = ''
  inputRef.value?.focus?.()
  imgCodeRef.value?.refresh?.()
}
defineExpose({
  refresh,
  value,
  uuid
})
</script>

<style lang="less">
.pic-verify {
  display: flex;
  gap: @margin-md;
  align-items: center;
  width: 100%;
  height: 100%;

  &--icon {
    .ant-input {
      padding-left: 10px !important;

      &-affix-wrapper {
        padding: 8px 15px;
        line-height: 1.5;
      }

      &-prefix {
        .anticon {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
